import React from 'react';
import '../../css/Layout.css';

const Footer = () => {
  return (
    <footer className="footer">
        <p>© 2025. ({localStorage.getItem("control_company_nm")}) All rights reserved.</p>
    </footer>
  );
};

export default Footer;